import { render, staticRenderFns } from "./SectionDescriptionDocumentsMobile.vue?vue&type=template&id=496e0c01&"
import script from "./SectionDescriptionDocumentsMobile.vue?vue&type=script&lang=js&"
export * from "./SectionDescriptionDocumentsMobile.vue?vue&type=script&lang=js&"
import style0 from "./SectionDescriptionDocumentsMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports